module.exports = __webpack_public_path__ + "img/askmebet-support.27b58b15.png";